module.exports = __webpack_public_path__ + "img/prod-icon2.83fef491.png";